export default "/yt-ezeth.efd0d996fcd6f93cad93eadd19a5a697.svg";